export default {
  async exportExcel ({dataOutType, search}) {
    let success = false
    await this.api(search.cmd, Object.assign({
      dataOutType
    }, search.search), {
      loading: {
        target: $('body')[0]
      }
    }).then(res => {
      if (res.data.code === '0') {
        success = true
      }
    })
    return success
  }
}
